import { cloneDeep } from "lodash-es";
import dayjs from "dayjs";
import DISTRICTS from "../../../comm/plugins/distPicker/districts.js";
import { isNil } from "lodash-es";
import { Dialog, Toast } from "vant";
import { transferAccountData } from "@/apis/resume.js";
// 根据dicValue获取dicName
/**
 * @description - 查询dicName
 * @param {Object} scope - 当前作用域
 */
export const getDicName = function(scope, dicsName, targetDicValue) {
  let foundArr = [];
  if (scope.dics[dicsName] && scope.dics[dicsName].length) {
    foundArr = scope.dics[dicsName].filter(val => val.value == targetDicValue);
    if (foundArr && foundArr.length) {
      return foundArr[0].name;
    }
  }
  return "";
};
/**
 * @description - 提交之前重置字典项和地址项
 * @param {Object} scope - 当前作用域
 * @param {Object} data - 简历内容
 */
export const rebuildData = function(scope, data) {
  for (let i = 0; i < scope.dataConfig.length; i++) {
    let item = scope.dataConfig[i];
    if (item.isDic) {
      let propWithoutName = item.prop.replace("Name", "");
      let propValue = data[`${propWithoutName}Value`];

      if (propValue && propValue.length) {
        propValue = propValue[0];
        data[item.prop] = getDicName(
          scope,
          item.dicsName || propWithoutName,
          propValue
        );

        data[propWithoutName] = propValue;
      } else {
        data[item.prop] = "";
        data[propWithoutName] = "";
      }

      if (item.noSubmitName) {
        data[item.prop] && delete data[item.prop];
      }

      delete data[`${propWithoutName}Value`];
    }

    if (item.isAddress) {
      let propValue = data[`${item.prop}Value`];

      if (propValue && propValue.length == 2) {
        // 中国：省-市
        let province = getAddress(scope, propValue[0], "value", "name");
        let city = getAddress(scope, propValue[1], "value", "name");

        if (province && city) {
          data[`${item.prop}`] = province + "-" + city;
        } else {
          data[`${item.prop}`] = "";
        }

        delete data[`${item.prop}Value`];
      } else if (propValue && propValue.length == 1) {
        // 海外：只存国家名
        data[`${item.prop}`] = propValue[0];

        delete data[`${item.prop}Value`];
      }
    }

    if (item.isYesOrNo) {
      // 如果是‘是’与‘否’选项
      if (data[item.prop]) {
        if (data[item.prop][0] === "true") {
          data[item.prop] = true;
        } else if (data[item.prop][0] === "false") {
          data[item.prop] = false;
        } else {
          data[item.prop] = void 0;
        }
      }
    }
  }
};
/**
 * @description - 校验必填项和格式
 * @param {Object} scope - 当前作用域
 * @param {Object} tempResumeInfo - 简历数据内容
 * @param {Boolean} [isMini] - 是否为微简历字段
 */
export const validate = function(scope, tempResumeInfo, isMini, silent) {
  const timeRangeMap = new Map();
  for (let i = 0; i < scope.dataConfig.length; i++) {
    let item = scope.dataConfig[i];
    let attr = item.prop;

    // 豁免必填的字段（如外籍时的籍贯）不参与必填校验
    const skipRequired =
      !!item.skipRequiredWhen && item.skipRequiredWhen(tempResumeInfo);

    if (item.required && !skipRequired) {
      if (item.isDic) {
        attr = item.prop.replace("Name", "");
      }

      if (
        !(
          (item.isDic && tempResumeInfo[attr] && tempResumeInfo[item.prop]) ||
          (!item.isDic && tempResumeInfo[attr]) ||
          (item.isYesOrNo && [true, false].includes(tempResumeInfo[attr]))
        )
      ) {
        // 如果是isDic 则需要校验attr和prop
        if (isMini) {
          if (item.miniRequired) {
            if (!silent) {
              scope.$toast.show({
                text: `${item.propName}为必填项`,
                type: "warn",
                time: 1000
              });
            }

            return false;
          } else {
            continue;
          }
        } else {
          if (!silent) {
            scope.$toast.show({
              text: `${item.propName}为必填项`,
              type: "warn",
              time: 1000
            });
          }
          return false;
        }
      }
    }

    //存在校验规则
    if (
      item.rule &&
      Object.prototype.toString.call(item.rule) === "[object Array]"
    ) {
      // 存在多个校验
      for (let r of item.rule) {
        if (!validCustomRule(r, item, tempResumeInfo, silent)) {
          return false;
        }
      }
    } else {
      if (!validCustomRule(item.rule, item, tempResumeInfo, silent)) {
        return false;
      }
    }

    if (item.isTimeRangeFlag) {
      // 如果是时间段标识 需要找到与之配对的另一个 然后对其值进行大小对比
      // 结束时间不能早于开始时间
      if (!item.timeRangeName) {
        // 没有设置唯一标识
        throw new Error(
          `${item.propName}(${item.prop}) lackof field timeRangeName!`
        );
      }

      if (!item.timeRangePosition) {
        // 没有设置开始/结束时间标识
        throw new Error(
          `${item.propName}(${item.prop}) lackof field timeRangePosition!`
        );
      }

      setTimeRangeMapByTimeRangePosition(
        timeRangeMap,
        item.timeRangeName,
        item.timeRangePosition,
        tempResumeInfo[attr]
      );
    }
  }

  for (let key of timeRangeMap.keys()) {
    const [start, end] = timeRangeMap.get(key);

    if (new Date(end).getTime() < new Date(start).getTime()) {
      if (!silent) {
        scope.$toast.show({
          text: `结束时间不能早于开始时间`,
          type: "warn",
          time: 1000
        });
      }
      return false;
    }
  }

  return true;

  function setTimeRangeMapByTimeRangePosition(dataMap, key, position, value) {
    if (!dataMap.has(key)) {
      dataMap.set(key, []);
    }

    if (position === "start") {
      dataMap.get(key)[0] = value;
    } else if (position === "end") {
      dataMap.get(key)[1] = value;
    } else {
      throw new Error("lackof rangePosition!");
    }
  }

  function validCustomRule(rule, val, subData, silent) {
    if (
      rule &&
      rule.fn &&
      !rule.fn.call(scope, subData[val.prop], subData, scope)
    ) {
      //校检失败
      if (!silent) {
        scope.$toast.show({
          text: rule.customMessage
            ? rule.customMessage
            : `${val.propName}${rule.message || "格式错误！"}`,
          type: "warn",
          time: 2000
        });
      }

      return false;
    }

    return true;
  }
};
/**
 * @description - 获取地区（默认返回地区的name）
 * @param {Object} scope - 当前作用域
 * @param {String} value - 需要查询的值（value/name）
 * @param {String} queryType - 需查询的类型（'value'/'name'）
 * @param {String} returnType - 需返回的类型（'value'/'name'）
 */
export const getAddress = function(scope, value, queryType, returnType) {
  let foundArr = DISTRICTS.filter(val => val[queryType] == value);
  if (foundArr && foundArr.length) {
    return foundArr[0][returnType || "name"];
  } else {
    return "";
  }
};

/**
 * @description - 获取地区数组
 */
export const getDistricts = function() {
  return DISTRICTS;
};
/**
 * 提交成功回调
 */
const submitResumeSuccess = function(scope, res) {
  const that = scope;
  that.$loading.hide();
  that.$toast.show({
    text: "提交成功",
    type: "success",
    time: 1000
  });

  that.$store.commit("setResumeInfo", null);
  that.$store.commit("updateMyResume", null);
  that.$store.commit("setAnalysisResume", null);

  if (that.$route.query.editVisibleType) {
    that.$router.go(-1);
  } else {
    that.$emit("back");
  }
};
export const submitResumeByArrBuildData = function(scope, editType) {
  let that = scope;
  let tempResumeInfo = cloneDeep(that.resumeInfo);

  if (!tempResumeInfo.name) {
    that.$toast.show({
      text: "请先填写完善个人信息",
      type: "warn",
      time: 1000
    });
    return;
  }

  // 删除数据项
  const list = tempResumeInfo[editType] || [];
  if (list.length) {
    for (let index = 0; index < list.length; index++) {
      const item = list[index];
      //重置一遍数据
      rebuildData(that, item);
      //校验数据
      if (!validate(that, item)) {
        return;
      }
    }
  }

  // 教育信息时间段重叠校验
  if (editType === "educationList" && hasEducationTimeOverlap(list)) {
    that.$toast.show({
      text: getEducationTimeOverlapTip(that, list),
      type: "warn",
      time: 3000
    });
    return;
  }

  tempResumeInfo[editType] = list;
  return tempResumeInfo;
};
// 账号迁移校验提示
export const accountMigrationVerificationTip = function(
  params,
  status,
  message
) {
  if (status === 506) {
    // 弹框二次确认（三要素核验通过，可重新绑定）
    Dialog.confirm({
      message: `<div><div>${message}</div><div class='warning'>*重新绑定后，旧手机所绑定的账号数据将迁移至此账号（迁移后旧账号数据将被重置），请谨慎处理。</div></div>`,
      title: "身份证已存在",
      confirmButtonText: "重新绑定",
      cancelButtonText: "取消",
      className: "resume-account-migration-verification-tip",
      allowHtml: true
    }).then(async () => {
      const [res] = await transferAccountData(params);
      if (res) {
        Toast.success("账号迁移成功");
        this.$store.commit("setRefreshResumeFlag", false);
        this.$store.commit("updateMyResume", res || {});
        this.$store.commit("setResumeInfo", res || {});
        this.$store.commit("setAnalysisResume", res || {});
        this.$router.go(-1);
      }
    });
  } else if (status === 508) {
    // 弹框提示账号已被绑定（三要素核验不过）
    Dialog.confirm({
      message: `<div>${message}</div>`,
      title: "提交失败",
      confirmButtonText: "确定",
      showCancelButton: false,
      className: "resume-account-migration-verification-tip",
      allowHtml: true
    });
    // Dialog.confirm(message, "身份证已存在", {
    //   confirmButtonText: "确定",
    //   showCancelButton: false
    // });
  } else if (status === 501) {
    Toast.fail(message);
  }
};
export const onSubmitResumeByArr = async function(that, tempResumeInfo) {
  //提交
  that.$loading.show({
    text: "提交中"
  });

  const [res, err] = await that.$store.dispatch("submitResume", tempResumeInfo);

  const { id, idType, idNumber, name } = tempResumeInfo;

  if (err) {
    that.$loading.hide();
    if (err.code) {
      accountMigrationVerificationTip.call(
        that,
        {
          id,
          idType,
          idNumber,
          name
        },
        err.code,
        err.errorMsg
      );
    } else {
      that.$toast.show({
        text: err.message || "提交失败",
        type: "cancel",
        time: 1000
      });
    }

    if (that.$route.query.editVisibleType) {
      that.$router.go(-1);
    } else {
      that.$emit("back");
    }
  } else {
    submitResumeSuccess(that, res);

    // 清空简历缓存
    that.$store.commit("setResumeInfo", null);
    that.$store.commit("setAnalysisResume", null);
  }
};
/**
 * @description - 简历提交（多条记录的模块）
 * @param {Object} scope - 作用域
 * @param {Object} editType - 编辑的模块
 */
export const submitResumeByArr = async function(scope, editType) {
  const tempResumeInfo = submitResumeByArrBuildData(scope, editType);

  tempResumeInfo && onSubmitResumeByArr(scope, tempResumeInfo);
};
/**
 * @description - 简历提交（单条记录模块）
 * @param {Object} scope - 当前作用域
 * @param {String} editType - 编辑的模块
 * @param {Boolean} [isMini] - 是否微简历模块
 */
export const submitResume = async function(scope, editType, isMini) {
  let that = scope;
  let tempResumeInfo = that.$deepCopyExtend(that.resumeInfo);

  if (editType != "baseInfo" && !tempResumeInfo.name) {
    // 必须是个人信息模块填写后才能填写其他
    that.$toast.show({
      text: "请先填写完善个人信息",
      type: "warn",
      time: 1000
    });
    return;
  }

  //重置一遍数据
  rebuildData(that, tempResumeInfo);

  if (!validate(that, tempResumeInfo, isMini)) {
    return;
  }

  //提交
  that.$loading.show({
    text: "提交中"
  });

  const { id, idType, idNumber, name } = tempResumeInfo;

  const [res, err] = await that.$store.dispatch("submitResume", tempResumeInfo);

  that.$loading.hide();
  if (err) {
    const { message, status, code, errorMsg } = err;
    // const { message, status, code, errorMsg } = {
    //   message: "提交失败",
    //   status: 508,
    //   code: 508,
    //   errorMsg: "提交失败"
    // };

    if (message === "已存在同名及证件号的简历" || status === 10020001) {
      that.$Modal.confirm.show({
        title: "",
        content: `您输入的证件号码${tempResumeInfo.idNumber}已经注册简历，请核实证件号码是否正确？如确认输入正确，原账号将不可用。`,
        onCancel() {
          console.log("cancel");
        },
        async onConfirm() {
          let params = {
            name: tempResumeInfo.name,
            idNumber: tempResumeInfo.idNumber
          };
          that.$loading.show({
            text: "提交中"
          });

          const [res, err] = await that.$store.dispatch(
            "resetUserInfo",
            params
          );
          that.$loading.hide();

          if (err) {
            return that.$toast.show({
              text: "提交失败",
              type: "cancel",
              time: 1000
            });
          }

          if (res) {
            submitResume(scope, editType, isMini);
          }
        }
      });
    } else if (code) {
      accountMigrationVerificationTip.call(
        that,
        {
          id,
          idType,
          idNumber,
          name
        },
        code,
        errorMsg
      );
    } else {
      Toast.fail(err.message || "提交失败");
    }
    return;
  }
  submitResumeSuccess(that, res);
};

/**
 * @description - 初始化简历数据（多条记录模块）
 * @param {Object} scope - 当前作用域
 * @param {String} editType - 当前初始化模块
 */
export const getResumeInfoByArr = function(scope, editType) {
  let that = scope;
  that.resumeLoaded = false;
  const {
    resumeInfo,
    refreshResumeFlag,
    analysisResume,
    resumeEagleFlag
  } = scope.$store.state.resume;
  // 如果有简历解析数据回来，则用解析数据
  if (analysisResume) {
    cb(analysisResume);
    return Promise.resolve(analysisResume);
  }
  // 如果已有简历数据并且不强制刷新
  if (resumeInfo && !refreshResumeFlag) {
    cb(resumeInfo);
    return Promise.resolve(resumeInfo);
  }
  const isEagle = {};
  if (resumeEagleFlag) {
    isEagle.type = "eagle";
  }
  return new Promise((resolve, reject) => {
    //获取自己简历信息
    that.$axios
      .get(`web/resume/my`, {
        params: { ...isEagle, time: new Date().getTime() }
      })
      .then(
        res => {
          if (!res) {
            scope.resumeLoaded = true;
            // reject();
            scope.$toast.show("请先维护个人信息！");
            scope.$router.back();
            return;
          }
          scope.$store.commit("setRefreshResumeFlag", false);
          scope.$store.commit("setResumeInfo", res);
          cb(res);
          resolve(res);
        },
        err => {
          reject(err);
          that.$toast.show({
            text: (err && err.msg) || "请求失败",
            type: "text",
            time: 1000
          });
        }
      );
  });
  function cb() {
    that.resumeLoaded = true;
  }
};

export const handleProps = (scope, mainInfo) => {
  let that = scope;
  for (let i = 0; i < that.dataConfig.length; i++) {
    let item = that.dataConfig[i];

    if (item.isDic) {
      let tempPropValue = [];
      const prop = item.prop.replace("Name", "");
      if (mainInfo[prop] != void 0) {
        tempPropValue = [mainInfo[prop].toString()];
      } else {
        let currentDics = that.dics[prop];
        if (currentDics && currentDics.length) {
          //给个默认值
          tempPropValue = [currentDics[0].value.toString()];
        }
      }
      that.$set(mainInfo, `${prop}Value`, tempPropValue);
    } else if (item.isYesOrNo) {
      // 是与否
      const resultStr = resetYesOrNoField({
        data: mainInfo,
        conf: item
      });

      that.$set(mainInfo, `${item.prop}`, resultStr);
    }
  }
};

/**
 * @description - 初始化简历数据（单条记录模块）,获取不到简历时，除基本信息外都返回上一页
 * @param {Object} scope - 当前作用域
 */
export const getResumeInfo = function(scope, isBaseInfo) {
  let that = scope;
  that.resumeLoaded = false;
  const {
    resumeInfo,
    refreshResumeFlag,
    analysisResume,
    resumeEagleFlag
  } = scope.$store.state.resume;
  // 如果有简历解析数据回来，则用解析数据
  if (analysisResume) {
    cb(analysisResume);
    return Promise.resolve(analysisResume);
  }
  if (resumeInfo && !refreshResumeFlag) {
    cb(resumeInfo);
    return Promise.resolve(resumeInfo);
  }
  const isEagle = {};
  if (resumeEagleFlag) {
    isEagle.type = "eagle";
  }
  return new Promise((resolve, reject) => {
    //获取自己简历信息
    that.$axios
      .get(`web/resume/my`, {
        params: { ...isEagle, time: new Date().getTime() }
      })
      .then(
        res => {
          if (res) {
            that.$store.commit("setRefreshResumeFlag", false);
            that.$store.commit("setResumeInfo", res);
            cb(res);
            resolve(res);
          } else {
            that.resumeLoaded = true;
            if (!isBaseInfo) {
              that.$toast.show("请先维护个人信息！");
              that.$router.back();
            }
          }
        },
        err => {
          reject(err);
          that.$toast.show({
            text: (err && err.msg) || "请求失败",
            type: "text",
            time: 1000
          });
        }
      );
  });
  function cb(res) {
    that.resumeInfo = that.$deepCopyExtend(res);
    that.resumeLoaded = true;
    //重置dic项、地址项
    resetDataByConf({
      scope: that,
      data: that.resumeInfo,
      conf: that.dataConfig,
      dics: that.dics
    });
  }
};

/**
 * 重置dic项目、地址项
 * @param {object} scope 作用域
 * @param {object} data 简历数据
 * @param {object} conf 简历配置
 * @param {object} dics 字典下拉选项
 */
export function resetDataByConf(params = {}) {
  // 设置默认值
  const { scope, data, conf, dics, hasDefault } = Object.assign(
    { hasDefault: true },
    params
  );

  for (let i = 0; i < conf.length; i++) {
    let item = conf[i];

    if (item.prop)
      if (item.isDic) {
        // 字典
        resetDicField({
          scope,
          data,
          conf: item,
          dics,
          hasDefault
        });
      } else if (item.isAddress) {
        // 地址类
        resetAddressField({
          scope,
          data,
          conf: item
        });
      } else if (item.isYesOrNo) {
        // 是与否
        const resultStr = resetYesOrNoField({
          data,
          conf: item
        });

        scope.$set(data, `${item.prop}`, resultStr);
      }
  }
}

/**
 * 将布尔值转换为数组中第一个元素字符串
 * 例如：true => ['true']
 */
export function resetYesOrNoField({ data, conf } = {}) {
  let yesOrNo = [];

  if (!isNil(data[conf.prop])) {
    yesOrNo = [data[conf.prop].toString()];
  }

  return yesOrNo;
}

/**
 * 给数据添加一个XXXValue字段的属性 会改变原对象的值 作用于地址类字段
 * @param {object} data 简历信息
 * @param {object} conf 字段配置信息
 * @param {array} dics 字典类型下拉选项列表
 */
export function resetAddressField({ scope, data, conf } = {}) {
  let address = [];

  let addressArr = (data[conf.prop] && data[conf.prop].split("-")) || "";

  if (addressArr && addressArr.length == 2) {
    // 中国：省-市
    let province = getAddress(scope, addressArr[0], "name", "value");
    // 直辖市省市同名，市级需限定在省内查找，否则会取到省级编码
    let cityArr = DISTRICTS.filter(
      val => val.parent == province && val.name == addressArr[1]
    );

    address = [province, cityArr.length ? cityArr[0].value : ""];
  } else if (addressArr && addressArr.length == 1) {
    // 海外：只存了国家名
    address = [addressArr[0]];
  }

  scope.$set(data, `${conf.prop}Value`, address);
}

/**
 * 给数据添加一个XXXValue字段的属性 会改变原对象的值 作用于字典类字段
 * @param {object} data 简历信息
 * @param {object} conf 字段配置信息
 * @param {array} dics 字典类型下拉选项列表
 */
export function resetDicField({ scope, data, conf, dics, hasDefault } = {}) {
  if (!scope) {
    throw new Error("lackof scope");
  }

  let tempPropValue = [];

  if (data[conf.prop.replace("Name", "")]) {
    tempPropValue = [data[conf.prop.replace("Name", "")]];
  } else {
    if (!hasDefault) {
      return;
    }

    // 找到当前选项列表
    let currentDics = dics[conf.dicsName || conf.prop.replace("Name", "")];

    if (currentDics && currentDics.length) {
      // 给个默认值
      tempPropValue = [currentDics[0].value];
    }
  }

  scope.$set(data, `${conf.prop.replace("Name", "")}Value`, tempPropValue);
}

/**
 * @description - 查询字典
 * @param {Object} scope - 当前作用域
 * @param {string} type - 字典列表名
 */
export const getDic = function(scope, type) {
  let that = scope;
  that.$axios.get(`bsd/dictionary/queryDictionary/${type}`).then(
    res => {
      let tempRes = res.map(val => {
        return {
          value: val.dicValue,
          name: val.dicName
        };
      });

      tempRes && that.$set(that.dics, type, tempRes);
    },
    err => {
      that.$toast.show({
        text: (err && err.msg) || "请求失败",
        type: "warn",
        time: 1000
      });
    }
  );
};

//过滤数组
export const filterArr = function(arr, to, from) {
  if (!arr) return [];
  return arr.filter(
    (val, $index) => $index >= (from || 0) && $index < (to || arr.length)
  );
};

// 解析结果追加
export const ANALYSIS_ARR_BLOCKS = [
  "educationList",
  "workList",
  "projectList",
  "works",
  "rewardList",
  "managerList",
  "competitionList",
  "armyList"
];

export const mergeAnalysisResume = function(originResume, analysisResume) {
  const origin = originResume || {};
  const analysis = analysisResume || {};
  const merged = cloneDeep(analysis);

  ANALYSIS_ARR_BLOCKS.forEach(block => {
    const originList = (Array.isArray(origin[block]) ? origin[block] : []).filter(
      record => record && record.id != null && record.id !== ""
    );
    const analysisList = Array.isArray(analysis[block]) ? analysis[block] : [];

    if (originList.length || analysisList.length) {
      merged[block] = [...cloneDeep(originList), ...cloneDeep(analysisList)];
    }
  });

  // 保留原简历 id，否则保存时会走新增而不是更新
  if (origin.id) {
    merged.id = origin.id;
  }

  return merged;
};

// 两条时间段是否重叠
const isTimeRangeOverlap = function(rangeA, rangeB) {
  return rangeA.start < rangeB.end && rangeB.start < rangeA.end;
};

/**
 * @description - 是否第二学位
 */
const isSecondMajorRecord = function(record) {
  const value = record && record.isSecondMajor;
  if (value === true || value === "true") return true;
  return Array.isArray(value) && value[0] === "true";
};

/**
 * @description - 把一条教育记录转成可比较的时间区间
 */
const toEducationTimeRange = function(record) {
  if (!record || isSecondMajorRecord(record)) return null;

  return {
    record,
    start: dayjs(record.admissionTime).valueOf(),
    end: dayjs(record.graduationTime).valueOf()
  };
};

/**
 * @description - 找出第一对时间段重叠的教育记录
 * @param {Array<Object>} educationList 教育记录数组
 * @returns {{first: Object, second: Object}|null} 第一对重叠的记录，无重叠返回 null
 */
export const findEducationTimeOverlapPair = function(educationList) {
  const ranges = (educationList || [])
    .map(toEducationTimeRange)
    .filter(range => range !== null);

  for (let i = 0; i < ranges.length; i++) {
    for (let j = i + 1; j < ranges.length; j++) {
      if (isTimeRangeOverlap(ranges[i], ranges[j])) {
        return { first: ranges[i].record, second: ranges[j].record };
      }
    }
  }

  return null;
};

/**
 * @description - 教育经历列表中是否存在时间段重叠
 * @param {Array<Object>} educationList 教育记录数组
 * @returns {Boolean} true = 存在重叠
 */
export const hasEducationTimeOverlap = function(educationList) {
  return findEducationTimeOverlapPair(educationList) !== null;
};

/**
 * @description - 取一条教育记录的学历名
 * 已保存记录直接用 educationDegreeName;本地新增/自动补充的记录回退到字典查询
 * 注意:部分调用方(如 resume-new.vue)没有 dics,此时只认 educationDegreeName
 */
const getEducationDegreeName = function(scope, record) {
  if (!record) return "";

  if (record.educationDegreeName) return record.educationDegreeName;

  const degreeValue =
    record.educationDegreeValue && record.educationDegreeValue.length
      ? record.educationDegreeValue[0]
      : record.educationDegree;

  if (degreeValue === "" || degreeValue == null) return "";

  if (!scope || !scope.dics) return "";

  return getDicName(scope, "education", degreeValue);
};

// 硕士研究生 -> 硕士、大学本科 -> 本科
const shortenEducationDegreeName = function(name) {
  return (name || "").replace(/大学|研究生/, "");
};

/**
 * @description - 取一条教育记录的学历字典值
 * 兼容 picker 的 educationDegreeValue 数组与保存态的 educationDegree 标量
 * 空值/非法值返回 MAX_SAFE_INTEGER,排序时排到最后
 */
export const getEducationDegreeValue = function(record) {
  if (!record) return Number.MAX_SAFE_INTEGER;

  const raw =
    record.educationDegreeValue && record.educationDegreeValue.length
      ? record.educationDegreeValue[0]
      : record.educationDegree;

  if (raw === "" || raw === null || raw === void 0) {
    return Number.MAX_SAFE_INTEGER;
  }

  const value = Number(raw);

  return isNaN(value) ? Number.MAX_SAFE_INTEGER : value;
};

/**
 * @description - 找出所有参与时间段重叠的教育记录,按原列表顺序去重
 * @param {Array<Object>} educationList 教育记录数组
 * @returns {Array<Object>} 参与重叠的记录,无重叠返回空数组
 */
export const findEducationTimeOverlapRecords = function(educationList) {
  const ranges = (educationList || [])
    .map(toEducationTimeRange)
    .filter(range => range !== null);

  const overlapIndexes = new Set();

  for (let i = 0; i < ranges.length; i++) {
    for (let j = i + 1; j < ranges.length; j++) {
      if (isTimeRangeOverlap(ranges[i], ranges[j])) {
        overlapIndexes.add(i);
        overlapIndexes.add(j);
      }
    }
  }

  return [...overlapIndexes]
    .sort((a, b) => a - b)
    .map(index => ranges[index].record);
};

/**
 * @description - 教育经历时间重叠的提示文案,带上冲突的学历名
 * @param {Object} scope - 当前作用域(取 dics 用)
 * @param {Array<Object>} educationList 教育记录数组
 * @returns {String} 提示文案
 */
export const getEducationTimeOverlapTip = function(scope, educationList) {
  const names = [];

  findEducationTimeOverlapRecords(educationList).forEach(record => {
    const name = shortenEducationDegreeName(
      getEducationDegreeName(scope, record)
    );

    if (name && !names.includes(name)) {
      names.push(name);
    }
  });

  const prefix = names.length ? `${names.join("、")}的` : "";

  return `${prefix}教育信息（主修）存在时间重叠的情况，请检查核实`;
};

export default {
  rebuildData,
  getDicName,
  validate,
  getAddress,
  getDistricts,
  submitResume,
  submitResumeByArr,
  getResumeInfoByArr,
  getResumeInfo,
  getDic,
  filterArr,
  mergeAnalysisResume,
  findEducationTimeOverlapPair,
  hasEducationTimeOverlap
};



// WEBPACK FOOTER //
// ./src/modules/personal/js/commonFunction.js